<template>
  <div class="base">
    <div class="base-title">课程详情</div>
    <EditorView :data="data.introduce" />
  </div>
</template>
<script>
export default {
  name: "detailBase",
  components: {},
  props: {
    data: {
      type: Object,
      default: () => ({
        introduce: "",
      }),
    },
  },
  data() {
    return {};
  },
  methods: {},
};
</script>
<style lang="scss" scoped>
@import "@/style/variable";
.base {
  background: white;
  padding: 15px;
  &-title {
    font-size: 18px;
    margin-bottom: 20px;
  }
}
</style>
